export interface BankAccountLabelParts {
  /** The ledger account, e.g. `1930`. Absent when the account is unmapped or the caller is not staff. */
  ledger?: string;
  /** Bank display name plus masked number, e.g. `SEB ••7881`. */
  tail: string;
  /** The whole one-line label, e.g. `1930 · SEB ••7881`. */
  full: string;
}

/**
 * The one-line account label shown on transaction rows, in the detail dialog and in filters
 * (FIN-802, design Draft B): `<ledger> · <bank> ••<last 4>`. Each missing part is dropped
 * rather than filled in, so a label never shows a placeholder number.
 * See specs/transaction-bank-account-column/requirements.md (EC1, EC3).
 */
export function formatBankAccountLabel(input: {
  bankDisplayName: string;
  maskedNumber: string | null | undefined;
  chartAccountNumber?: string | null;
}): BankAccountLabelParts {
  const tail = [input.bankDisplayName, input.maskedNumber].filter(Boolean).join(' ');
  const ledger = input.chartAccountNumber || undefined;
  return {
    ...(ledger ? { ledger } : {}),
    tail,
    full: ledger ? `${ledger} · ${tail}` : tail,
  };
}
